const rankPerfectMatch = (options) => (options?.a === options?.b ? 8 : 0);

export default rankPerfectMatch;
